import { render, staticRenderFns } from "./IdentityVerify.vue?vue&type=template&id=77f883de&scoped=true&"
import script from "./IdentityVerify.vue?vue&type=script&lang=js&"
export * from "./IdentityVerify.vue?vue&type=script&lang=js&"
import style0 from "./IdentityVerify.vue?vue&type=style&index=0&id=77f883de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f883de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f883de')) {
      api.createRecord('77f883de', component.options)
    } else {
      api.reload('77f883de', component.options)
    }
    module.hot.accept("./IdentityVerify.vue?vue&type=template&id=77f883de&scoped=true&", function () {
      api.rerender('77f883de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/IdentityVerify.vue"
export default component.exports